import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FareRulesDetailModule } from '@common/components/modals/my-booking-itinerary/fare-rules-detail/fare-rules-detail.module';
import { MilesFormatModule } from '@common/pipes/miles-format/miles-format.module';
import { AmountFormatModule, StaticMsgModule } from '@lib/pipes';
import { MyBookingPaymentComponent } from './my-booking-payment.component';
import { MyBookingSlidebarMenuModule } from '@app/my-booking/sub-components/my-booking-slidebar-menu/my-booking-slidebar-menu.module';

@NgModule({
  declarations: [MyBookingPaymentComponent],
  imports: [
    CommonModule,
    StaticMsgModule,
    AmountFormatModule,
    MilesFormatModule,
    FareRulesDetailModule,
    MyBookingSlidebarMenuModule,
  ],
  exports: [MyBookingPaymentComponent],
})
export class MyBookingPaymentModule {}
